import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { getAboutAris } from "../../Services/aboutAris";
import "./style.css";

const LegalDocument = ({ documentType, cssPrefix, hideLogo = false, hideScrollDown = false }) => {
  const navigate = useNavigate();
  const { setHeaderContent } = useHeader();
  const [documentData, setDocumentData] = useState(null);

  useEffect(() => {
    setHeaderContent(false);
    const fetchDocumentData = async () => {
      try {
        const response = await getAboutAris(documentType);
        if (response) {
          setDocumentData(response);
        }
      } catch (error) {
        console.error(`Error fetching ${documentType} data:`, error);
      }
    };

    fetchDocumentData();
  }, [documentType]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const isAtBottom =
        window.innerHeight + scrollPosition >= document.documentElement.scrollHeight;

      const scrollDownElement = document.querySelector(`.${cssPrefix}-navigate-bottom`);
      if (scrollDownElement) {
        scrollDownElement.style.display = isAtBottom ? "none" : "block";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [cssPrefix]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleNavigation = () => {
      navigate(-1);
    };

    if (documentData) {
      const logoContainer = document.querySelector(`.${cssPrefix}-logo-container`);
      const scrollDownBtn = document.querySelector(`.${cssPrefix}-navigate-bottom div`);
      const scrollUpBtn = document.querySelector(`.${cssPrefix}-navigate-icon div`);

      if (logoContainer) {
        if (hideLogo) {
          logoContainer.style.visibility = 'hidden';
        }
        logoContainer.addEventListener("click", handleNavigation);
      }

      if (scrollDownBtn && !hideScrollDown) {
        scrollDownBtn.addEventListener("click", scrollToBottom);
      } else if (scrollDownBtn) {
        // Hide the scroll down button if not needed
        scrollDownBtn.parentElement.style.display = 'none';
      }

      if (scrollUpBtn) {
        scrollUpBtn.addEventListener("click", scrollToTop);
      }
    }

    return () => {
      const logoContainer = document.querySelector(`.${cssPrefix}-logo-container`);
      const scrollDownBtn = document.querySelector(`.${cssPrefix}-navigate-bottom div`);
      const scrollUpBtn = document.querySelector(`.${cssPrefix}-navigate-icon div`);

      if (logoContainer) {
        logoContainer.removeEventListener("click", handleNavigation);
      }
      if (scrollDownBtn) {
        scrollDownBtn.removeEventListener("click", scrollToBottom);
      }
      if (scrollUpBtn) {
        scrollUpBtn.removeEventListener("click", scrollToTop);
      }
    };
  }, [documentData, cssPrefix, navigate, hideLogo, hideScrollDown]);

  return (
    <>
      {documentData && (
        <div 
          className={`${cssPrefix}-container`}
          dangerouslySetInnerHTML={{ __html: documentData.content }}
        />
      )}
    </>
  );
};

export default LegalDocument;
